export default {
  hasOrganization(state) {
    return state.organization?.uuid;
  }
};
